module.exports = __webpack_public_path__ + "img/mejorubi.0de39f21.svg";